import { render } from "./CustomerType.vue?vue&type=template&id=e8161540&scoped=true"
import script from "./CustomerType.vue?vue&type=script&lang=js"
export * from "./CustomerType.vue?vue&type=script&lang=js"

import "./CustomerType.vue?vue&type=style&index=0&id=e8161540&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8161540"]])

export default __exports__